import { Children, cloneElement, isValidElement, type CSSProperties, type ReactElement, type ReactNode } from 'react'
import { cx } from './utils/cx'

export type ActivityVariant = 'done' | 'pulse' | 'idle'

interface ActivityItemProps {
  variant?: ActivityVariant
  text?: ReactNode
  when?: ReactNode
  first?: boolean
  className?: string
  style?: CSSProperties
}

export function ActivityItem({ variant = 'done', text, when, first, className, style }: ActivityItemProps) {
  return (
    <div className={cx('st-activity-item', variant, first && 'first', className)} style={style}>
      <span className="node" aria-hidden />
      <div className="body">
        <div className="t">{text}</div>
        {when && <div className="w">{when}</div>}
      </div>
    </div>
  )
}

export function Timeline({
  children,
  className,
  style
}: {
  children?: ReactNode
  className?: string
  style?: CSSProperties
}) {
  const arr = Children.toArray(children)
  return (
    <div className={cx('st-timeline', className)} style={style}>
      {arr.map((c, i) =>
        isValidElement(c) && c.type === ActivityItem
          ? cloneElement(c as ReactElement<ActivityItemProps>, {
              first: i === 0,
              key: (c as ReactElement).key ?? i
            })
          : c
      )}
    </div>
  )
}
